export default __webpack_public_path__ + "static/media/exam.1dbe7ace.jpg";